import { getDistanceCost, getHourlyIntervalTimeCost } from '../utils';
import { resolveB2CRates } from '../constants';
import { CalculationData, CalculationStrategy } from './calculation-strategy';

export class CaregivingWithUsersCarStrategy implements CalculationStrategy {
  calculate(data: CalculationData) {
    const CAREGIVING_WITH_USERS_CAR_PRICE_PER_HOUR = 15;

    if (!data?.travel) {
      throw new Error('Travel data is required');
    }

    if (
      !data?.caregivingDuration &&
      typeof data.caregivingDuration !== 'number'
    ) {
      throw new Error('Caregiving duration is required');
    }

    const travelDistance = data.travel.getTravelDistance();
    const driverDistance = data.travel.getDriverDistance();
    const timeCost = getHourlyIntervalTimeCost(
      data?.caregivingDuration,
      CAREGIVING_WITH_USERS_CAR_PRICE_PER_HOUR,
      data.reservationCreationDate
    );

    // Kasko
    const fiftyKmChunks = Math.ceil(travelDistance / 50);
    const kaskoCost =
      fiftyKmChunks *
      resolveB2CRates(data.reservationCreationDate).KASKO_PER_50KM;

    const distanceCost = getDistanceCost(
      driverDistance,
      0,
      data.reservationCreationDate
    );

    return {
      timeCost,
      distanceCost,
      caregivingDuration: data.caregivingDuration,
      kaskoCost,
      driverDistance,
      travelDistance,
      totalCost: timeCost + distanceCost + kaskoCost,
    };
  }
}
